<template>
  <v-dialog v-model="localValue" scrollable width="800" lazy persistent>
    <v-card>
      <v-toolbar color="primary" dense dark>
        <v-toolbar-title>
          {{ $t('titles.global.confirmation') }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="py-0">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex>
              <div class="mb-2">
                {{ $tc('fields.global.type') }}:
                {{ $t(`fields.notifications.type.${type}`) }}
              </div>
              <div class="mb-2">
                {{ $t('titles.notifications.sendDate') }}:
                {{ sendDate | format }}
              </div>
              <div v-if="count.hasOwnProperty('push')" class="mb-2">
                {{
                  `${$t('titles.notifications.receivers')} (${$t(
                    'fields.notifications.sendTypes.push'
                  )})`
                }}: {{ count.push }}
              </div>
              <div v-if="count.hasOwnProperty('email')" class="mb-2">
                {{
                  `${$t('titles.notifications.receivers')} (${$t(
                    'fields.notifications.sendTypes.email'
                  )})`
                }}:
                {{ count.email }}
              </div>
              <div>
                {{ $tc('models.country', 2) }}:
                {{ country || $t('action.buttons.all') }}
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="close" />
        <meta-button type="create" @click="submit" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDate } from '@/helpers/dateHelper'
export default {
  name: 'DialogReceiversCount',
  filters: {
    format: (value) => formatDate(value, true),
  },

  props: {
    value: { type: Boolean, default: false },
    sendDate: {
      type: Date,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    count: {
      type: Object,
      required: true,
    },
    country: {
      type: String,
      required: true,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    submit() {
      this.$emit('submit')
      this.close()
    },

    close() {
      this.localValue = false
    },
  },
}
</script>
